<template>
    <section class="relative w-full h-screen overflow-hidden">
        <!-- Banner Carousel -->
        <div class="relative h-full">
            <div v-for="(slide, index) in slides" :key="index"
                class="absolute w-full h-full bg-cover bg-center transition-opacity duration-5000" :style="{
                    backgroundImage: `url(${slide.imageUrl})`,
                    opacity: currentSlide === index ? 1 : 0,
                }">
                <div
                    class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center text-white px-4">
                    <div>
                        <h2 class="text-3xl md:text-5xl font-bold mb-4">{{ slide.title }}</h2>
                        <p class="mb-6">{{ slide.description }}</p>
                        <router-link to="/about"
                            class="px-6 py-3 bg-blue-500 hover:bg-blue-600 rounded text-white transition">
                            Learn More
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
            <button v-for="(slide, index) in slides" :key="index" class="w-3 h-3 rounded-full transition bg-white"
                :class="{ 'bg-blue-500': currentSlide === index }" @click="setSlide(index)"></button>
        </div> -->
    </section>
    <SectionOne />
    <CouncilPage />
    <SectionTwo />
    <SectionThree />
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import SectionOne from '../components/Landing/SectionOne.vue';
import SectionTwo from '../components/Landing/SectionTwo.vue';
import SectionThree from '../components/Landing/SectionThree.vue';
import CouncilPage from '../pages/CouncilPage.vue';
export default {
    components: {
        SectionOne,
        SectionTwo,
        CouncilPage,
        SectionThree,
    },
    name: "LandingPage",
    setup() {
        const slides = [
            {
                imageUrl: "/banners/b-1.jpg",
                title: "Welcome to Bhawal Sena Club",
                description: " A Journey from Dreams to Success",
            },
            {
                imageUrl: "/banners/b-3.jpg",
                title: "Discover New Opportunities",
                description: "A Steadfast Partner in Turning Dreams into Reality",
            },
            {
                imageUrl: "/banners/b3.jpg",
                title: "Gallery of Memories",
                description: "Committed to Transforming Dreams into Reality",
            },
        ];

        const currentSlide = ref(0);
        const slideInterval = ref(null);

        const setSlide = (index) => {
            currentSlide.value = index;
        };

        const startAutoSlide = () => {
            slideInterval.value = setInterval(() => {
                currentSlide.value = (currentSlide.value + 1) % slides.length;
            }, 5000);
        };

        const stopAutoSlide = () => {
            if (slideInterval.value) clearInterval(slideInterval.value);
        };

        onMounted(() => {
            startAutoSlide();
        });

        onUnmounted(() => {
            stopAutoSlide();
        });

        return {
            slides,
            currentSlide,
            setSlide,
        };
    },
};
</script>

<style scoped>
section {
    position: relative;
}

section div {
    transition: opacity 1s ease-in-out;
}

button {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: white;
    transition: background-color 0.3s;
}

button.bg-blue-500 {
    background-color: #4299e1;
    /* Blue */
}

/* Mobile responsiveness */
@media (max-width: 768px) {
    section {
        width: auto;
    }

    section div {
        width: 100vw;
        height: auto;
        /* Adjust the height for mobile */
    }
}

@media (max-width: 480px) {
    section div {
        height: 100vh;
        /* Further adjust for very small screens */
    }
}
</style>
